"use client";

import { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import righticom from "../../assets/images/plan/right-tik.svg";
import wrongicom from "../../assets/images/plan/wrong-tik.svg";
import api from "../../services/api";
import passimage from '../../assets/images/register_icon/call_brown.svg';

const PLAN_ORDER = {
  free: 1,
  silver: 2,
  gold: 3,
  platinum: 4,
};

const PricingSection = () => {
  const [billing, setBilling] = useState("yearly");
  const [servicePlans, setServicePlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  useEffect(() => {
    servicePlan();
  }, []);

  const servicePlan = async () => {
    try {
      const res = await api.get("/service-plan/get-all");
      console.log("servicePlan response:", res.data);
      setServicePlans(res.data?.data || []);
    } catch (error) {
      console.error("servicePlan API error:", error);
      toast.error("Failed to load service plans.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (plan) => {
    const vendorStorage = localStorage.getItem("vendor");
    if (!vendorStorage) {
      toast.error("Vendor information not found. Please log in again.");
      return;
    }

    setSelectedPlan(plan);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedPlan(null);
  };

  /*
   * Filter and order: Free -> Silver -> Gold -> Platinum
   */
  const plans = servicePlans
    .filter((plan) => plan.plan_type?.toLowerCase() === billing.toLowerCase())
    .sort((a, b) => {
      const orderA = PLAN_ORDER[a.plan_name?.toLowerCase()] || 99;
      const orderB = PLAN_ORDER[b.plan_name?.toLowerCase()] || 99;

      if (orderA !== orderB) {
        return orderA - orderB;
      }
      return Number(a.rank || 0) - Number(b.rank || 0);
    });

  if (loading) {
    return (
      <div className="contanier">
        <section className="priceing-section">
          <div className="pricing-container">
            <p>Loading plans...</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="contanier">
      {/* Container to display toast notifications */}
      <Toaster position="top-right" reverseOrder={false} />

      <section className="priceing-section">
        {/* Toggle */}
        <div className="billing-togglee">
          <button
            className={billing === "monthly" ? "active" : ""}
            onClick={() => setBilling("monthly")}
          >
            Monthly
          </button>

          <button
            className={billing === "yearly" ? "active" : ""}
            onClick={() => setBilling("yearly")}
          >
            Yearly
          </button>
        </div>

        {/* Pricing Cards */}
        <div className="pricing-container">
          {plans.map((plan) => {
            const isRecommended = plan.plan_name?.toLowerCase() === "gold";
            const isVerified = plan.plan_name?.toLowerCase() === "platinum";
            const features = plan.features || [];

            const features_active = features.filter(
              (feature) =>
                !feature.serviceplantitle
                  ?.trim()
                  .toLowerCase()
                  .startsWith("no ")
            );

            const features_inactive = features.filter((feature) =>
              feature.serviceplantitle
                ?.trim()
                .toLowerCase()
                .startsWith("no ")
            );

            return (
              <div
                key={plan.id}
                className={`pricing-card ${
                  isRecommended
                    ? "pricing-card-recommended recommended"
                    : ""
                }`}
              >
                {/* Recommended Badge */}
                {isRecommended && (
                  <div className="recommended-badge">Recommended</div>
                )}

                {/* Plan Name */}
                <div className="nameverified">
                  <h2>{plan.plan_name}</h2>
                  {isVerified && <span className="verified">/Verified</span>}
                </div>

                {/* Price */}
                <div>
                  <h2 className="halvetica">
                    <sup>₹</sup>
                    {Number(plan.price || 0).toLocaleString("en-IN")}
                  </h2>

                  <p className="price-sub">
                    {billing === "yearly"
                      ? "annual (inclusive of GST)"
                      : "monthly (inclusive of GST)"}
                  </p>
                </div>

                {/* Choose Plan Button */}
                <button
                  disabled={plan.plan_name?.toLowerCase() === "free"}
                  onClick={() => handleOpenModal(plan)}
                  className={
                    isRecommended
                      ? "button-container-recommended"
                      : plan.plan_name?.toLowerCase() === "free"
                      ? "button-container"
                      : "button-container-other"
                  }
                >
                  {plan.plan_name?.toLowerCase() === "free"
                    ? "Current Plan"
                    : "Choose Plan"}
                </button>

                {/* Features */}
                <div className="dis-list">
                  {/* Active Features */}
                  {features_active.length > 0 && (
                    <ul>
                      {features_active.map((feature, i) => (
                        <li key={i} className="active">
                          <div className="tik-icon">
                            <img
                              src={righticom}
                              alt="icon"
                              style={{ marginTop: "4px" }}
                            />
                          </div>

                          <div>
                            <p
                              className="active-feature"
                              style={{ textAlign: "left" }}
                            >
                              {feature.serviceplantitle}
                            </p>

                            {feature.serviceplandiscription && (
                              <span id="active-description">
                                {feature.serviceplandiscription}
                              </span>
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}

                  {/* Inactive Features */}
                  {features_inactive.length > 0 && (
                    <ul>
                      {features_inactive.map((feature, i) => (
                        <li key={i} className="active">
                          <div>
                            <img src={wrongicom} alt="icon" />
                          </div>

                          <div>
                            <span
                              style={{
                                color: "#B1B1B1",
                                fontSize: "16px",
                              }}
                              id="disable"
                            >
                              {feature.serviceplantitle}
                            </span>

                            {feature.serviceplandiscription && (
                              <span
                                style={{
                                  display: "block",
                                  color: "#B1B1B1",
                                  fontSize: "14px",
                                }}
                              >
                                {feature.serviceplandiscription}
                              </span>
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            );
          })}

          {/* No Plans */}
          {plans.length === 0 && <p>No {billing} plans available.</p>}
        </div>
      </section>

      {/* Contact Modal (Matching Bashaarat Page Design) */}
      {isModalOpen && (
        <div style={styles.modalOverlay} onClick={handleCloseModal}>
          <div style={styles.modalCard} onClick={(e) => e.stopPropagation()}>
            <button style={styles.closeBtn} onClick={handleCloseModal}>
              ✕
            </button>
            
            <div style={styles.badge}>
              {selectedPlan?.plan_name} Plan
            </div>

            <h3 style={styles.title}>Upgrade Your Listing</h3>
            
            <p style={styles.description}>
              For further process, please contact us. Our team will help activate your <strong>{selectedPlan?.plan_name}</strong> package listings within 24–48 hours.
            </p>

            <a href="tel:9967636592" style={styles.callButton}>
              <span >
                <img src={passimage} alt="Call" style={{ 
                      marginRight: "8px", 
                      height: "20px", 
                      filter: "brightness(20.5)" 
                }} />
              </span>+91 91368 33292
            </a>

            <p style={styles.subText}>Available (9:00 AM - 6:00 PM)</p>
          </div>
        </div>
      )}
    </div>
  );
};

// CSS-in-JS styles matched to the Bashaarat theme design
const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(18, 48, 38, 0.65)", // Dark teal transparent backdrop
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "20px",
  },
  modalCard: {
    backgroundColor: "#FAF6EF", // Bashaarat cream background color
    border: "1px solid #D1C5B4",
    borderRadius: "16px",
    padding: "36px 28px 28px 28px",
    width: "100%",
    maxWidth: "500px",
    textAlign: "center",
    position: "relative",
    boxShadow: "0 15px 35px rgba(0, 0, 0, 0.2)",
    fontFamily: "inherit",
  },
  closeBtn: {
    position: "absolute",
    top: "16px",
    right: "18px",
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
    color: "#888888",
    padding: "4px",
    lineHeight: "1",
  },
  badge: {
    display: "inline-block",
    backgroundColor: "#0B4234", // Bashaarat deep green badge
    color: "#FFFFFF",
    padding: "4px 16px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: "600",
    textTransform: "capitalize",
    marginBottom: "16px",
  },
  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#222222",
    marginBottom: "12px",
    marginTop: "0px",
  },
  description: {
    fontSize: "15px",
    color: "#555555",
    lineHeight: "1.5",
    marginBottom: "24px",
  },
  callButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#C36E2B", // Bashaarat warm brown action button
    color: "#FFFFFF",
    padding: "14px 20px",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    textDecoration: "none",
    boxShadow: "0 4px 10px rgba(195, 110, 43, 0.3)",
    transition: "all 0.2s ease-in-out",
  },

  subText: {
    fontSize: "12px",
    color: "#888888",
    marginTop: "16px",
    marginBottom: "0px",
  },
};

export default PricingSection;